import { SET_SUCCESS_FEEDBACK, WAITING_REQUEST } from "../utils/constants";

function wrapperAppReducer(state, action) {
  switch (action.type) {
    case WAITING_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SET_SUCCESS_FEEDBACK:
      return {
        ...state,
        isSuccessProcess: action.value,
        isLoading: false
      };
    default:
      throw new Error();
  }
}

export default wrapperAppReducer;
